// ============================================================
// MY MOBILE MECHANIC — SITE SETTINGS
// Edit this file to update phone, hours, social links, videos
// and photos. No code changes needed anywhere else.
// ============================================================

export const SITE = {
  name: "My Mobile Mechanic",
  tagline: "Mobile Brake Replacement — We Come to You",

  phone: "(978) 967-9860",
  phoneHref: "tel:+19789679860",
  smsHref: "sms:+19789679860",

  hours: "Monday – Saturday: 8:00 AM – 5:00 PM",
  hoursShort: "Mon–Sat 8am–5pm",
  closedNote: "Closed Sundays",
  serviceArea: "Middlesex County, MA & Southern New Hampshire",

  socials: {
    facebook: "https://www.facebook.com/share/1chscmPpXD/",
    instagram: "https://www.instagram.com/my_mobile_mechanic_",
    tiktok: "https://www.tiktok.com/@mymobilemechanic978",
    youtube: "https://youtube.com/@mymobilemechanic978",
  },
  followerCount: "2,000,000",

  // TODO(owner): paste your Google Business Profile links
  googleReviewsUrl: "https://www.google.com/search?q=My+Mobile+Mechanic+reviews",
  googleLeaveReviewUrl: "https://www.google.com/search?q=My+Mobile+Mechanic+reviews",

  // Booking — owner takes all appointments by call/text (no online scheduling)
  booking: {
    note: "Call or text to book — most brake jobs are scheduled within days.",
  },

  // Featured social videos — swap thumbnails & links anytime.
  // Kept as lightweight cards (no heavy auto-loading embeds) for speed.
  featuredVideos: [
    {
      platform: "YouTube",
      title: "Full brake job, start to finish — in a driveway",
      url: "https://youtube.com/@mymobilemechanic978",
      thumb:
        "https://images.unsplash.com/photo-1760317890322-364a810cd4da?auto=format&fit=crop&w=900&q=70",
      alt: "Mechanic replacing a brake rotor and caliper during a mobile brake repair",
    },
    {
      platform: "TikTok",
      title: "How to tell your rotors are shot in 10 seconds",
      url: "https://www.tiktok.com/@mymobilemechanic978",
      thumb:
        "https://images.unsplash.com/photo-1629480980351-ec8ad9945c27?auto=format&fit=crop&w=900&q=70",
      alt: "Close-up of a car wheel being serviced during a mobile brake replacement",
    },
    {
      platform: "Instagram",
      title: "Before & after: seized caliper rescue",
      url: "https://www.instagram.com/my_mobile_mechanic_",
      thumb:
        "https://images.unsplash.com/photo-1617932624157-d1963c3c9441?auto=format&fit=crop&w=900&q=70",
      alt: "Bright brake caliper behind a wheel after a mobile brake repair",
    },
  ],

  // Repair photo gallery — REAL My Mobile Mechanic 978 job photos (uploaded by owner 2026-09-13).
  gallery: [
    {
      src: "/images/owner-van.jpg",
      alt: "The owner of My Mobile Mechanic 978 with his mobile repair van, ready for on-site brake service",
      category: "mobile-repairs",
      caption: "The man behind the van",
    },
    {
      src: "/images/real-new-rotor.jpg",
      alt: "Brand-new coated brake rotor installed on a customer's car during a mobile brake replacement",
      category: "brake-jobs",
      caption: "New rotor going on",
    },
    {
      src: "/images/real-new-pads.jpg",
      alt: "Technician fitting new brake pads into the caliper bracket during an on-site brake job",
      category: "brake-jobs",
      caption: "Fresh pads & hardware",
    },
    {
      src: "/images/real-old-new-rotors.jpg",
      alt: "Worn drilled brake rotor next to its brand-new replacement on a driveway brake job",
      category: "before-after",
      caption: "Old rotor vs. new",
    },
    {
      src: "/images/real-worn-pad.jpg",
      alt: "Completely worn-out brake pad removed during a mobile brake job, worn down to the metal",
      category: "before-after",
      caption: "Worn down to metal",
    },
    {
      src: "/images/real-rusty-rotor.jpg",
      alt: "Rusted and grooved brake rotor before replacement at a customer's home",
      category: "before-after",
      caption: "Before: rusted & grooved",
    },
    {
      src: "https://images.unsplash.com/photo-1781751419897-9c926f079b90?auto=format&fit=crop&w=1200&q=75",
      alt: "Professional mobile mechanic working on a customer vehicle at their home",
      category: "mobile-repairs",
      caption: "On-site at a customer's home",
    },
    {
      src: "https://images.unsplash.com/photo-1702146713858-8e7d1cc29fe8?auto=format&fit=crop&w=1200&q=75",
      alt: "Mobile mechanic working underneath a vehicle with professional tools",
      category: "behind-scenes",
      caption: "Under the car, on location",
    },
    {
      src: "https://images.unsplash.com/photo-1676018366904-c083ed678e60?auto=format&fit=crop&w=1200&q=75",
      alt: "Organized mobile workshop tools laid out for a repair appointment",
      category: "behind-scenes",
      caption: "Tools staged for the job",
    },
  ],
};

export const GALLERY_CATEGORIES = [
  { id: "all", label: "All Work" },
  { id: "brake-jobs", label: "Brake Jobs" },
  { id: "before-after", label: "Before & After" },
  { id: "mobile-repairs", label: "Mobile Repairs" },
  { id: "behind-scenes", label: "Behind the Scenes" },
];
